/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Gsoa_ProductCatalog_Enums_GetCountries_response } from '../models/Gsoa_ProductCatalog_Enums_GetCountries_response';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaProductCatalogEnumsService {
    /**
     * Kolekce zemí původu
     * @returns Gsoa_ProductCatalog_Enums_GetCountries_response OK
     * @throws ApiError
     */
    public static getEnumsCountries({
        houseNumber,
        apiVersion = 1,
        page,
        pageSize = 50,
        filter,
        listedProductsOnly,
        actionProducts,
    }: {
        houseNumber: number,
        apiVersion?: number,
        /**
         * Page order number (starts at 0)
         */
        page?: number,
        /**
         * The number of items per page
         */
        pageSize?: number,
        /**
         * <b>Filtering on response attributes</b>
         * <p>
         * <details>
         * <summary>Supported operators:</summary>
         * <p><i>in</i> - checks if attribute equals one of posibilities. Case sensitive when literal attribute.</p>
         * </details>
         * <details>
         * <summary>Supported attributes - examples:</summary>
         * <p>Id:in Abc,def,ghi</br></p>
         * </details>
         * </p>
         */
        filter?: string,
        /**
         * Filter only items active in products catalog
         */
        listedProductsOnly?: boolean,
        /**
         * Filter only items active in action offers
         */
        actionProducts?: boolean,
    }): CancelablePromise<Gsoa_ProductCatalog_Enums_GetCountries_response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/enums/{houseNumber}/countries',
            path: {
                'apiVersion': apiVersion,
                'houseNumber': houseNumber,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
                'filter': filter,
                'listedProductsOnly': listedProductsOnly,
                'actionProducts': actionProducts,
            },
            errors: {
                304: `Not Modified`,
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
